var map = {
	"./board.js": "483a",
	"./certificate.js": "90f3",
	"./configuration.js": "948c",
	"./courseCenter.js": "1f99",
	"./coursePlay.js": "a069",
	"./exam.js": "8cf9",
	"./face.js": "244b",
	"./gpt.js": "ec43",
	"./home.js": "1a2c",
	"./information.js": "b8a4",
	"./learn.js": "cb79",
	"./lecturer.js": "5b0e",
	"./live.js": "07ef",
	"./operationHomeWork.js": "7d90",
	"./order.js": "7724",
	"./practice.js": "f9df",
	"./resource.js": "ceb4",
	"./usercenter.js": "d6e7"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "a08a";